import { useEffect, useState } from 'react';

import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

import { createKbApi } from './createKbApi';

export const useCreateKbProjectIdentifier = ({
	projectId,
}: {
	projectId: number;
}): string | null => {
	const [projectIdentifier, setProjectIdentifier] = useState<string | null>(null);

	useEffect(() => {
		let isMounted = true;
		setProjectIdentifier(null);

		const fetchProjectIdentifier = async () => {
			try {
				const identifier = await createKbApi.fetchProjectIdentifierById({ projectId });
				if (isMounted) {
					setProjectIdentifier(identifier);
				}
			} catch (error) {
				logException({
					exception: error,
					name: 'CreateKBCardProjectIdentifierError',
					tags: {
						projectId: String(projectId),
					},
				});
			}
		};

		void fetchProjectIdentifier();

		return () => {
			isMounted = false;
		};
	}, [projectId]);

	return projectIdentifier;
};
